import Image from "next/image";
import React from "react";

export default function BasicSummary({ course }) {
  return (
    <>
      {/* {course?.description && ( */}
        <div className="at_a_glance">
          <div className="title-wrap">
            <Image
              src="/images/admission-icon/at-a-galance.png"
              alt="Price Tag"
              width={24}
              height={24}
            />
            <h2 className="title">এক নজরে</h2>
          </div>
          <div className="details-textarea">
            {course?.description ? (
              <div
                className="description"
                dangerouslySetInnerHTML={{ __html: course.description }} >
              </div>
            ) : null}
          </div>
        </div>
      {/* )} */}
    </>
  );
}
